import { FC } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { getGenericErrorMessage } from "@app/shared/utility/getGenericErrorMessage";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";
import { useUniqueGapFills } from "@app/compliance-connect/regulator/hooks/useUniqueGapFills";

const ComplianceConnectUniqueGapFillsWidget: FC = () => {
    const { uniqueGapFills, uniqueGapFillsError, isLoading: loading } = useUniqueGapFills();

    const renderContent = () => {
        if (loading) return <LoadingSpinner />;
        if (uniqueGapFillsError) return <QESAlert type="danger" persist>{getGenericErrorMessage()}</QESAlert>;
        return (
            <>
                <p className="compliance-connect-stat-widget__description">These gaps are filled by only 1 issuer</p>
                <p data-testid="compliance-connect-unique-gap-fills-count" className="compliance-connect-stat-widget__count compliance-connect-stat-widget__count--blue">
                    {(uniqueGapFills?.totalUniqueGapFills ?? 0).toLocaleString()}
                    <span data-testid="compliance-connect-unique-gap-fills-label" className="compliance-connect-stat-widget__label"> Gaps</span>
                </p>
            </>
        );
    };

    return (
        <QESWidget className="compliance-connect-stat-widget">
            <QESWidgetHeader>
                <QESWidgetTitle className="compliance-connect-stat-widget__title">TOTAL UNIQUE GAP FILLS</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
                {renderContent()}
            </QESWidgetContent>
        </QESWidget>
    );
};

export default ComplianceConnectUniqueGapFillsWidget;
